export default "__VITE_PUBLIC_ASSET__d9ec808b__"